import { render, staticRenderFns } from "./InfoForAudio.vue?vue&type=template&id=fa8f1dd0&"
import script from "./InfoForAudio.vue?vue&type=script&lang=js&"
export * from "./InfoForAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports